import { createFileRoute } from '@tanstack/react-router';
import { DetailsStepForm } from './-components/project-new-steps/details-step';

export const Route = createFileRoute('/ngos/portals/$portalId_/projects/new/details')({
	component: DetailsStepForm,
});
